import { takeEvery, put, call } from "redux-saga/effects"
import {POST_CANDIDATES_INTEREST_STATUS} from "./actionTypes"
import {postCandidateInterestStatusSuccess,postCandidateInterestStatusFail } from "./actions"
import {CandidateInterestFeedback} from "../../../../helpers/fakebackend_helper"
//restapi end point
import * as constClass from "../../../../common/constant/constantURL"
// submit feedback
function* postCandidateInterestHandler({ payload: {json} }) {
    try {
    let url = constClass.REST_API_CANDIDATEINTEREST+`?status=${json.status}&code=${json.code}`
    let responsJSON = yield call(CandidateInterestFeedback, url)
    yield put(postCandidateInterestStatusSuccess(responsJSON))
  }
  catch (error) {
    yield put(postCandidateInterestStatusFail(error))
  }
}



function* CandidateInterestSaga() {
  yield takeEvery(POST_CANDIDATES_INTEREST_STATUS, postCandidateInterestHandler);
}

export default CandidateInterestSaga